module.exports = __webpack_public_path__ + "img/404.44fa3373.svg";